<template>
  <div id="activityTopicsPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="نمودار سرفصل های فعالیت"></ActionBar>
    <div class="container mx-auto no-gutters p-0 mt-2">
      <div class="row">
        <div class="col-6 col-md-4 col-lg-3">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">از تاریخ:</span></div>
          <div>
            <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-left="100"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDate1"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    class="input-border"
                    color="forth"
                    dense
                    hide-details
                    readonly
                    solo></v-text-field>
              </template>
              <v-date-picker
                  v-model="date1"
                  color="forth"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePicker1"></v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-3">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">تا تاریخ:</span></div>
          <div>
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDate2"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    class="input-border"
                    dense
                    hide-details
                    readonly
                    solo></v-text-field>
              </template>
              <v-date-picker
                  v-model="date2"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePicker2"></v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-8 col-sm-6 col-md-4 col-lg-3">
          <div><i class="fas fa-chalkboard-teacher pl-1"></i><span class="font12px">فعالیت:</span></div>
          <v-autocomplete
              v-model="classId"
              :items="classesItems"
              class="input-border"
              color="white"
              dense
              hide-details
              item-text="Text"
              item-value="Value"
              solo></v-autocomplete>
        </div>
        <div class="col-4 col-sm-6 col-md-4 col-lg-3 align-self-end ">
          <v-btn color="forth" rounded><span class="white--text" @click="searchResult">جستجو</span></v-btn>
        </div>
      </div>
    </div>
    <div class="row container mx-auto no-gutters p-0 mt-10">
      <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
        در حال جستجو
        <v-progress-linear
            color="deep-purple accent-4"
            height="6"
            indeterminate
            rounded
        ></v-progress-linear>
      </div>
      <div v-else-if="isLoaded" class="col-12 col-sm-10 col-md-6 mx-auto border">
        <div v-if="!hasReport" class="mx-2 mt-5 knowledge-base-body">
          <div class="col-12">
            <v-alert
                border="bottom"
                class="text-center"
                color="forth"
                dark>
              گزارشی برای تاریخ انتخاب شده وجود ندارد.
            </v-alert>
          </div>
        </div>
        <div v-else>
          <PolarAreaChart v-if="isChartLoaded" :chart-data="loadChartData()" :chart-max="maxScore"
                          :chart-min="minScore" :chartLabel="loadChartLabel()"/>
        </div>
      </div>

      <PolarAreaChart v-if="isChartLoaded" :chart-data="loadChartData()" :chart-max="maxScore" :chart-min="minScore"
                      :chartLabel="loadChartLabel()" class="col-12"/>
    </div>

    <FooterMenu/>
  </div>
</template>

<script>
import moment from "moment-jalaali";
import ActionBar from "../../components/ActionBar";
import FooterMenu from "../../components/FooterMenu";
import PolarAreaChart from "../../components/PolarAreaChart";

let _this = null
export default {
  name: "ActivityTopics",
  components: {PolarAreaChart, FooterMenu, ActionBar},
  data: () => ({
    classId: null,
    classesItems: [],
    inputDate1: '',
    inputDate2: '',
    menu1: false,
    date1: '',
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu2: false,
    dataLoading: false,
    isLoaded: false,
    hasReport: false,
    isChartLoaded: false,
    chartLabel: ['هنری', 'ورزشی', 'تحصیلی', 'روانی', 'علمی', 'استراحت و ریکاوری', 'فراغت و سرگرمی'],
    chartData: [60, 100, 50, 45, 70, 35, 80],
    minScore: 0,
    maxScore: 100,
  }),
  mounted() {
    _this = this
    this.inputDate2 = this.$convertDate(this.date2)
    let current = new Date()
    current.setDate(current.getDate() - 365)
    this.date1 = current.toISOString().substr(0, 10)
    this.inputDate1 = this.$convertDate(this.date1)
    this.isChartLoaded = true

    this.getData()
  },
  methods: {
    inputDatePicker1() {
      this.menu1 = false

      this.inputDate1 = moment(this.date1).format('jYYYY/jMM/jDD')
    },
    inputDatePicker2() {
      this.menu2 = false
      this.inputDate2 = moment(this.date2).format('jYYYY/jMM/jDD')
    },
    getData() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/ActivityTopics", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.classesItems = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    searchResult() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", this.$convertDateToMiladi(this.inputDate1));
      urlencoded.append("EndDate", this.$convertDateToMiladi(this.inputDate2));
      urlencoded.append("EvaluationCategoryID", this.classId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_ActivityTopics", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log(json)
          })
          .catch(error => console.log('error', error));
    },
    loadChartData() {
      let arr = this.chartData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartLabel() {
      let arr = this.chartLabel;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
  }
}
</script>

<style scoped>

</style>